import type { NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw } from 'vue-router'
import { useLoadingStore } from '@/modules/core/stores/loadingStore'
import { resolveMediator } from './guards'
import { useCommonStore } from '@/modules/core/stores'

export const COMMON_RATER_ROUTES = [
  {
    path: '',
    name: 'rater-nav',
    component: () => import('../modules/common/common/views/NavView.vue'),
    beforeEnter: async (
      to: RouteLocationNormalized,
      _from: RouteLocationNormalized,
      next: NavigationGuardNext
    ) => {
      useLoadingStore().startLoading('common.loading.processing')
      const mediatorRedirect = await resolveMediator(to)
      useCommonStore().showLogo = true
      if (mediatorRedirect) {
        next(mediatorRedirect)
      } else {
        next()
      }
    }
  },
  {
    path: '/exit',
    name: 'exit',
    beforeEnter: () => {
      const urlDxpBack = import.meta.env.VITE_API_URL_DXP_ROOT
      window.location.replace(urlDxpBack || 'https://www.asisa.es')
    }
  }
] as RouteRecordRaw[]

export const COMMON_HIRING_ROUTES = []
